import './Services.css';

const services = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>
        <path d="M7 8h10M7 11h6"/>
      </svg>
    ),
    title: 'Website Development',
    tagline: 'Professional websites & web apps built to convert',
    desc: 'From landing pages to full-scale e-commerce platforms, we build fast, responsive, and SEO-optimized websites using React, Node.js, and WordPress.',
    slug: 'website-development',
    highlights: ['Landing Pages', 'E-commerce Stores', 'Web Apps', 'SEO Optimization', 'UI/UX Design', 'Maintenance'],
    accent: '#1800ad',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a4 4 0 0 1 4 4c0 1.5-.8 2.8-2 3.5V12l3 3-3 1v2l-2-1-2 1v-2l-3-1 3-3V9.5A4 4 0 0 1 8 6a4 4 0 0 1 4-4z"/>
        <circle cx="12" cy="19" r="3"/><path d="M9 19H5M19 19h-4"/>
      </svg>
    ),
    title: 'AI & ML Solutions',
    tagline: 'Intelligent systems that automate, analyze and decide',
    desc: 'We build custom AI models, integrate LLMs into your products, and create intelligent automation pipelines from chatbots to full NLP systems.',
    slug: 'ai-ml-solutions',
    highlights: ['AI Model Fine-Tuning', 'Chatbot Development', 'RAG Systems', 'Sentiment Analysis', 'API Integration', 'Automation'],
    accent: '#5b3fff',
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
        <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
        <line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/>
      </svg>
    ),
    title: 'Research & Technical Services',
    tagline: 'Academic excellence — writing, editing and technical support',
    desc: 'Professional academic writing, plagiarism removal, AI content humanizing, data analysis, and journal publication support for students and researchers.',
    slug: 'research-technical',
    highlights: ['Paper Writing', 'Plagiarism Removal', 'AI Content Removal', 'Data Analysis', 'Journal Formatting', 'Proofreading'],
    accent: '#ff7c90',
  },
];

export default function Services() {
  return (
    <section className="services-section" id="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">My <span>Services</span></h2>
          <p className="section-sub">End-to-end digital solutions with transparent pricing. Click any service to see full details and packages.</p>
        </div>
        <div className="services-grid">
          {services.map(s => (
            <div key={s.title} className="service-card" style={{ '--accent': s.accent }}>
              <div className="service-icon-wrap">{s.icon}</div>
              <h3>{s.title}</h3>
              <p className="service-tagline">{s.tagline}</p>
              <p className="service-desc">{s.desc}</p>
              <div className="service-highlights">
                {s.highlights.map(h => <span key={h} className="svc-tag">{h}</span>)}
              </div>
              <a href={'/services/' + s.slug} className="service-btn">View Pricing & Details →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
